/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdApplicationPublicDataBuilderPlatformDataOptionsAndroidOptions interface.
 */
export function instanceOfFxIdApplicationPublicDataBuilderPlatformDataOptionsAndroidOptions(value) {
    if (!('PackageName' in value) || value['PackageName'] === undefined)
        return false;
    if (!('AppLinkUrl' in value) || value['AppLinkUrl'] === undefined)
        return false;
    return true;
}
export function FxIdApplicationPublicDataBuilderPlatformDataOptionsAndroidOptionsFromJSON(json) {
    return FxIdApplicationPublicDataBuilderPlatformDataOptionsAndroidOptionsFromJSONTyped(json, false);
}
export function FxIdApplicationPublicDataBuilderPlatformDataOptionsAndroidOptionsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'PackageName': json['PackageName'],
        'AndroidClass': json['AndroidClass'] == null ? undefined : json['AndroidClass'],
        'AppLinkUrl': json['AppLinkUrl'],
    };
}
export function FxIdApplicationPublicDataBuilderPlatformDataOptionsAndroidOptionsToJSON(json) {
    return FxIdApplicationPublicDataBuilderPlatformDataOptionsAndroidOptionsToJSONTyped(json, false);
}
export function FxIdApplicationPublicDataBuilderPlatformDataOptionsAndroidOptionsToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'PackageName': value['PackageName'],
        'AndroidClass': value['AndroidClass'],
        'AppLinkUrl': value['AppLinkUrl'],
    };
}
//# sourceMappingURL=FxIdApplicationPublicDataBuilderPlatformDataOptionsAndroidOptions.js.map